import styled from 'styled-components';
import CoreButton from 'components/Buttons/CoreButton';

export const Container = styled.div`
  &&.titleContainer {
    display: flex;
    margin-top: 50px;
    margin-bottom: 10px;
  }
  .title {
    width: 180px;
    text-align: left;
    font-family: Roboto;
    letter-spacing: 0;
    color: #2b2727;
    opacity: 1;
    font-size: 24px;
    margin-top: 63px;
  }
  .validationButton {
    float: right;
  }
`;

export const GlobalBloc = styled.div`
  &&.globalBloc {
    position: relative;
    margin-top: 150px;
  }
`;
export const StyledButton = styled(CoreButton)`
  margin-top: 10px;
  margin-bottom: 20px;
  width: 300px;
  height: 40px;
  background: #ffc912;
  &:hover {
    background-color: #ffc912;
  }
`;
